
import Vue from 'vue';
import Component from 'vue-class-component';
import { BoListPanel } from 'bonomo/dist';
import { namespace } from 'vuex-class';
import { IUserLog } from '@/model/logs/Ilogs';
import { Prop } from 'vue-property-decorator';
import { BetterDataTableHeader } from '@/model/betterVuetifyInterfaces';
import WebhookLogErrorDialog from "@/components/settings/webhooks/WebhookLogErrorDialog.vue";

const userModule = namespace('userModule');
const webHookModule = namespace('webhookModule');

interface ILogAction {
  ori?: number | string; // origin:load-data="loadData"
}

@Component({
  name: 'WebhookLogs',
  components: {
    BoListPanel,
    WebhookLogErrorDialog,
  },
})
export default class WebhookLogs extends Vue {
  @Prop()
  protected userId!: number;

  @webHookModule.Getter('logs')
  private logs!: IUserLog[];

  @webHookModule.Action('fetchLogs')
  private fetchLogs!: ({ userId, filters }: any) => IUserLog;

  @webHookModule.Action('clearLogs')
  private clearLogs!: () => null;

  protected loading: boolean = false;
  protected expanded: boolean = false;
  protected subscribes: object = {};
  protected showDialog: boolean = false;


  protected get headers(): BetterDataTableHeader[] {
    return [
      {
        text: this.$t('common.when'),
        align: 'start',
        sortable: false,
        value: 'anyValue'
      },
    ];
  }

  created() {
    this.subscribes = this.$ons({
      'backend.call.KO.fetchLogs': this.onLogError,
    });
  }

  beforeDestroy() {
    this.$offs(this.subscribes);
  }

  private  onLogError() {
    // this.$uiBus.emit('info', , $t('please contact with the administrator'));
    this.showDialog = true;
  }

  private onHideDialog() {
    this.showDialog = false;
  }

  private loadData(filters: any) {
    this.clearLogs();
    this.fetchLogs({ userId: this.userId, filters });
  }

  private formatUserData(obj: ILogAction) {
    let newObj: ILogAction = { ...obj };
    if (newObj.ori) {
      newObj.ori =
          (this.$t('users.user.logs.origin.' + newObj['ori']) as string) || '???';
    }

    return newObj;
  }
}
